/**
 * Helpers for the optional MFA reminder flow.
 *
 * Backend source of truth:
 * - user.hasSeenTwoFactorQuestion
 * - user.twoFactorQuestionLastViewedAt (preferred for reminder cadence)
 */
const DAYS_TO_MS = 24 * 60 * 60 * 1000

export function isTwoFactorEnabled (user) {
  if (!user || typeof user !== 'object') {
    return false
  }
  const tfa = user.twoFactorAuthentication
  if (tfa && typeof tfa.enabled === 'boolean') {
    return tfa.enabled
  }
  return !!(
    user.twoFactorEnabled ||
    user.two_factor_enabled ||
    user.isTwoFactorEnabled ||
    user.is_two_factor_enabled ||
    user.mfaEnabled ||
    user.mfa_enabled
  )
}

export function hasSeenTwoFactorQuestion (user) {
  if (!user || typeof user !== 'object') {
    return false
  }
  return !!(
    user.hasSeenTwoFactorQuestion ||
    user.has_seen_two_factor_question
  )
}

export function getTwoFactorQuestionLastViewedAt (user) {
  if (!user || typeof user !== 'object') {
    return null
  }
  const raw =
    user.twoFactorQuestionLastViewedAt ??
    user.two_factor_question_last_viewed_at ??
    user.hasSeenTwoFactorQuestionAt ??
    user.has_seen_two_factor_question_at ??
    null
  if (!raw) {
    return null
  }
  const parsed = Date.parse(raw)
  return Number.isNaN(parsed) ? null : parsed
}

export function isTwoFactorQuestionPromptDue (user, cooldownDays = 30) {
  const lastViewedAt = getTwoFactorQuestionLastViewedAt(user)
  if (lastViewedAt == null) {
    return true
  }
  const cooldownMs = cooldownDays * DAYS_TO_MS
  return (Date.now() - lastViewedAt) >= cooldownMs
}
